module.exports = __webpack_public_path__ + "img/8bb6d73.svg";